import { render } from "./App.vue?vue&type=template&id=43320440"
const script = {}

import "./App.vue?vue&type=style&index=0&id=43320440&lang=scss"
script.render = render

export default script